<template>
  <el-dialog :attrs="attrs" :align-center="true" :close-on-click-modal="false" :center="true" overflow :lock-scroll="true">
    <template v-for="(value, name) in slots" #[name]="scopeData">
      <slot :name="name" v-bind="scopeData || {}"/>
    </template>
  </el-dialog>
</template>

<script setup>
import { useAttrs, useSlots } from 'vue';

const attrs = useAttrs();

const slots = useSlots();
</script>

<style lang="scss">
.el-overlay-dialog {
  @include responseTo("pc-1000px") {
    padding: 0 30px;
  }
  @include responseTo("ipad-999px-767px") {
    padding: 0 20px;
  }
  @include responseTo("web-766px") {
    padding: 0 15px;
  }
}
.el-dialog {
  --el-dialog-width: auto;
  border-radius: 20px;
  // @include responseTo("web-766px") {
  //   --el-dialog-width: calc(100%);
  //   max-width: 405px;
  //   min-width: calc(100% - 30px);
  // }
  .el-dialog__header.show-close {
    padding: 0 30px;
  }
  .el-dialog__headerbtn {
    background: url(~/assets/images/login-closure@2x.webp) no-repeat;
    background-position: center;
    background-size: 16px 16px;
    cursor: pointer;

    .el-dialog__close {
      display: none;
    }
  }
  @include responseTo('pc-1000px') {
    padding: 30px 0;
  }
  @include responseTo('ipad-999px-767px') {
    padding: 20px 0 !important;
    // max-width: 420px !important;
    // min-width: min(calc(100% - 20px), 420px) !important;
    border-radius: 20px !important;
  }

  @include responseTo("web-766px") {
    padding: 15px 0 !important;
    border-radius: 10px !important;
  }
  .el-dialog__title {
    font-weight: 600;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.95);
    text-align: center;
    font-family:
      SFPro,
      PingFang SC,
      Hiragino Sans GB,
      Microsoft YaHei,
      Arial,
      sans-serif;
  }
}
</style>
